<div class="mat-dialog-container">
  <mat-dialog-content>
    <h1>{{ stateAction }} member:</h1>
    <hr />
    <form class="add-member-form" [formGroup]="emailFormGroup" (ngSubmit)="onSubmit()">
      <div class="form-field">
        <mat-label class="form-field-label">Email:</mat-label>
        <mat-form-field appearance="outline">
          <input matInput type="text" formControlName="email" required autocomplete="off" />
          <mat-error *ngIf="emailFormGroup.get('email')?.invalid">
            Please enter a valid email.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="modal-footer">
        <button mat-button color="primary" class="add-button" type="submit">Confirm</button>
        <button mat-button class="close-button" [mat-dialog-close]="true">Close</button>
      </div>
    </form>
  </mat-dialog-content>
</div>
